import reduxThunk from 'redux-thunk';
import reduxHotjar from 'redux-hotjar';
import createMetricsMiddleware from './createMetricsMiddleware';
import createAnalyticsMiddleware from './createAnalyticsMiddleware';
import { metricsIsEnabled, sentryIsEnabled } from 'config';

let createErrorLoggingMiddleware;
const shouldUseLoggingMiddleware = sentryIsEnabled && ENV.CLIENT;

if (shouldUseLoggingMiddleware) {
  createErrorLoggingMiddleware = require('./createErrorLoggingMiddleware').default;
}

const staticMiddleware = [
  reduxHotjar(),
  reduxThunk,
  ...(metricsIsEnabled ? [createMetricsMiddleware()] : []),
  ...(shouldUseLoggingMiddleware ? [createErrorLoggingMiddleware()] : [])
];

export default ({ analytics }) => {
  return [
    ...staticMiddleware,
    ...[createAnalyticsMiddleware(analytics)]
  ];
};



/** WEBPACK FOOTER **
 ** ./app/store/middleware/index.js
 **/